/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest } from "shared/bootstrap";
import storeMod from "./store";
import publicLocale from "./i18n/public.json";

const manifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "my-license" },
      title: "compendalicense.menuItems.myLicense",
      icon: "box-check",
      hideNoAuth: true
    }
  ],
  routes: [
    {
      path: "/mijn-licentie",
      name: "my-license",
      meta: {
        auth: true,
        title: "compendalicense.menuItems.myLicense"
      },
      component: () => import("./pages/MyLicense.vue")
    }
  ],
  storeModules: {
    compendalicense: storeMod
  },
  widgets: [
    {
      name: "LicenseInfo",
      component: () => import("./widgets/LicenseInfo.vue")
    }
  ],
  localisation: { key: "compendalicense", messages: publicLocale }
};

export default manifest;
